// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { WorkOrderFormSettingsPage } from '#components/domain/operations/settings/work-order-form-settings-page.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'

export const Route = createFileRoute('/_appSettings/$companyId/settings/work-order-templates')({
  component: RouteComponent,
})

/** Settings page for Work Order Templates — the form-settings editor (templates reuse the work-order catalogs). */
function RouteComponent() {
  return (
    <WorkOrderFormSettingsPage
      entityType="work_order_template"
      permissionService={PermissionService.WORK_ORDER_TEMPLATES}
      titleKey="workOrderTemplatesSettings.title"
      descriptionKey="workOrderTemplatesSettings.description"
    />
  )
}
